// import React from "react";
// import { FiSearch } from "react-icons/fi";
// import { MdLocationOn, MdKeyboardArrowDown } from "react-icons/md";
// import { assets } from "../../../Assets/assets";
// import { useNavigate } from "react-router-dom";
// import CommonButton from "../../Common/CommonButton";

// const Hero = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="relative bg-[#FFECF1] rounded-[40px] overflow-hidden">
//       {/* LEFT DECOR */}
//       <img
//         src={assets.homevector}
//         alt="left"
//         className="absolute left-0 top-0 w-32 md:w-44"
//       />

//       {/* RIGHT DECOR */}
//       <img
//         src={assets.homevector2}
//         alt="right"
//         className="absolute right-0 top-0 w-32 sm:w-32 md:w-44"
//       />

//       {/* CONTENT */}
//       <div className="2xl:max-w-7xl mx-auto text-center px-4 py-36 md:py-20">
//         {/* HEADING */}
//         <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-[#3D0F1B] to-subPrimaryColor mb-5 md:mb-6">
//           Welcome to the Fast Lane of <span>Secure</span>
//           <br />
//           Trade
//         </h1>

//         {/* SUBTEXT */}
//         <p className="text-secondaryTextColor text-sm md:text-base mb-4">
//           Experience lightning-fast quotations, the lowest prices in India, and
//           a platform built for reliability, transparency, and growth.
//         </p>

//         {/* SEARCH BAR */}
//         {/* <div className="flex items-center mb-4 bg-white rounded-full shadow-sm px-2 sm:px-4 py-1 max-w-3xl mx-auto">

//           <div className="flex items-center sm:gap-2 text-primaryColor font-medium pr-2 sm:pr-4 border-r border-gray-200">
//             <MdLocationOn className="text-lg" />
//             <span className="hidden sm:block">Delivery to</span>
//             <MdKeyboardArrowDown />
//           </div>

//           <div className="flex items-center flex-1 px-4">
//             <FiSearch className="text-gray-400 mr-2 text-lg" />
//             <input
//               type="text"
//               placeholder="Search for product"
//               className="w-full outline-none text-sm"
//             />
//           </div>

//           <button className="bg-subPrimaryColor hover:bg-subPrimaryBtnHoverColor text-white w-12 h-12 flex items-center justify-center rounded-full transition">
//             <FiSearch className="text-lg" />
//           </button>
//         </div> */}

//         <CommonButton
//           onClick={() => navigate("/post-requirement")}
//           label="Post Your Requirement Here"
//         />
//       </div>
//     </div>
//   );
// };

// export default Hero;
import React from "react";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Common/CommonButton";
import { assets } from "../../../Assets/assets";
import { useAuth } from "../../Context/AuthContext";

const Hero = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="relative overflow-hidden h-[80vh] md:h-[90vh]">
      <div className="w-full h-full flex flex-col items-center">
        {/* MAIN IMAGE */}
        <div className="w-full h-full mb-8 md:mb-12">
          <img
            src={assets.bannerImg}
            alt="Hero Banner"
            className="w-full h-full hidden sm:block object-fill"
          />
          <img
            src={assets.herobannerphone}
            alt="Hero Banner"
            className="w-full h-full block sm:hidden"
          />
        </div>

        {/* BUTTON */}
        <div className="px-4 pb-10 md:pb-16">
          <CommonButton
            onClick={() =>
              user?.role === "supplier"
                ? navigate("/supplier-rqm-requests")
                : navigate("/post-requirement")
            }
            label={
              user?.role === "supplier"
                ? "Go for RQM section"
                : "Ask for a Quick Quotation"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
